module.exports = __webpack_public_path__ + "static/media/appbrewery_logo.60ca92c6.png";